import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Question = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="question icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 6.61207C7.5 4.04578 9.53364 2 12 2C14.4664 2 16.5 4.04578 16.5 6.61207C16.5 8.11141 15.5059 9.11425 14.0764 10.4172C14.0216 10.4671 13.9659 10.5177 13.9095 10.5689L13.9094 10.569C12.6413 11.7201 11 13.21 11 15.5V16.5C11 17.0523 11.4477 17.5 12 17.5C12.5523 17.5 13 17.0523 13 16.5V15.5C13 14.1506 13.9592 13.23 15.4236 11.8953L15.4698 11.8532C16.7847 10.6552 18.5 9.09219 18.5 6.61207C18.5 2.97944 15.6088 0 12 0C8.39123 0 5.5 2.97944 5.5 6.61207C5.5 7.16435 5.94772 7.61207 6.5 7.61207C7.05228 7.61207 7.5 7.16435 7.5 6.61207ZM12 20C11.4477 20 11 20.4477 11 21V23C11 23.5523 11.4477 24 12 24C12.5523 24 13 23.5523 13 23V21C13 20.4477 12.5523 20 12 20Z"
    />
  </svg>
)
